import { cn } from '@/lib/utils';

/** An exported glyph at an exact pixel size. */
export function Icon({ src, size = 14, className }: { src: string; size?: number; className?: string }) {
  return (
    <span className={cn('relative block shrink-0 overflow-clip', className)} style={{ width: size, height: size }}>
      <img alt='' src={src} className='protocol-glyph absolute inset-0 block size-full max-w-none' />
    </span>
  );
}
